import { getToken } from '@/utils/auth';
import Errors404 from '@/views/404';
import Errors500 from '@/views/500';
import LandingPage from '@/views/landingPage/index.vue'
import Appstore from '@/views/appstore/index.vue';
import AppDetail from '@/views/appstore/appDetail';
import Docs from '@/views/docs/index';
import Apps from '@/views/index/appList';
import Index from '@/views/index/Index';
import MarketRegist from '@/views/index/Regist';
import LayoutCertification from '@/views/layout/LayoutCertification';
import LoginLayout from '@/views/layout/LayoutLogin';
import Login from '@/views/login/index';
import storeLogin from '@/views/login/storeLogin';
import Publisher from '@/views/Publisher/index.vue';
import Register from '@/views/register/index';
import ForgetPassword from '@/views/resetPassword/index';
import Vue from 'vue';
import Router from 'vue-router';
/* customer-manage */
import customerManageRouter from './modules/customerManage';
/* deliver-manage */
import deliverManageRouter from './modules/deliverManage';
/* enterprise-app */
import enterpriseAppRouter from './modules/enterpriseApp';
/* enterprise-manage */
import enterpriseManageRouter from './modules/enterpriseManage';
/* enterprise-order */
import enterpriseOrderRouter from './modules/enterpriseOrder';
import overviewRouter from './modules/overviewEnterprise';
import payStepsRouter from './modules/paySteps';
/* store-manage */
import storeManageRouter from './modules/storeManage';
/* warning-info */
import warningInfoRouter from './modules/warningInfo';

import myAppRouter from './modules/myApp';
import publishAppRouter from './modules/publishApp';

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
// app详情
const constantRouterMap = [
  {
    path: '/',
    name: 'landingPage',
    component: LandingPage,
    hidden: true
  },
  {
    path: '/index',
    name: 'index',
    // component: Index,
    redirect: '/',
    hidden: true
  },
  {
    path: '/marketregist',
    name: 'marketregist',
    component: MarketRegist,
    hidden: true
  },
  {
    path: '/apps',
    name: 'applist',
    component: Apps,
    hidden: true
  },
  {
    path: '/marketplace',
    name: 'appstore',
    component: Appstore,
    hidden: true
  },
  {
    // path: '/markets/:marketID/publisher/:publisherID',
    path: '/marketplace/publisher/:publisherID',
    name: 'publisher',
    component: Publisher,
    hidden: true
  },
  {
    path: '/marketplace/apps/:appID',
    name: 'appDetail',
    component: AppDetail,
    hidden: true
  },
  {
    path: '/enterprise',
    name: 'enterpriseUser',
    component: LoginLayout,
    hidden: true,
    children: [
      {
        path: 'register',
        name: 'register',
        component: Register,
        hidden: true
      },
      {
        path: 'login',
        name: 'login',
        component: storeLogin,
        hidden: true
      },
      {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: ForgetPassword,
        hidden: true
      }
    ]
  },
  {
    path: '/certification',
    name: 'certification',
    component: LayoutCertification,
    hidden: true,
    redirect: '/certification/login',
    children: [
      {
        path: 'register',
        name: 'certificationRegister',
        component: Register,
        hidden: true
      },
      {
        path: 'login',
        name: 'certificationLogin',
        component: Login,
        hidden: true
      },
      {
        path: 'forgetPassword',
        name: 'certificationForgetPassword',
        component: ForgetPassword,
        hidden: true
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true },
  {
    path: '/404',
    name: '404',
    component: Errors404,
    hidden: true
  },
  {
    path: '/500',
    name: '500',
    component: Errors500,
    hidden: true
  }
];
const oauthRouter = [
  overviewRouter,
  enterpriseAppRouter,
  warningInfoRouter,
  enterpriseOrderRouter,
  storeManageRouter,
  deliverManageRouter,
  customerManageRouter,
  enterpriseManageRouter,
  payStepsRouter,
  myAppRouter,
  publishAppRouter
];
const asyncRouterMap = [...constantRouterMap, ...oauthRouter];
var router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        // 這個是透過 to.hash 的值來找到對應的元素
        // 照你的 html 來看是不用多加處理這樣就可以了
        // 例如你按下 #3 的連結，就會變成 querySelector('#3')，自然會找到 id = 3 的元素
        selector: to.hash
      };
    }
    return new Promise((resolve, reject) => {
      resolve({ x: 0, y: 0 });
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
  routes: asyncRouterMap
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    if (getToken() && getToken() != '') {
      next();
    } else {
      if (window.location.href.indexOf('certification') > -1) {
        next({
          name: 'certificationLogin'
        });
      } else {
        next({
          name: 'login',
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js